module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Modal = __webpack_require__(1);
	var Header = __webpack_require__(9);
	var Body = __webpack_require__(13);

	module.exports = { Modal: Modal, Header: Header, Body: Body };

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(2);
	var css = __webpack_require__(3);
	var React = __webpack_require__(7);
	var FlexModalWrapper = __webpack_require__(8);
	var PropTypes = React.PropTypes;

	__webpack_require__(2); // eslint-disable-line require-path-exists/exists

	var Modal = function Modal(_ref) {
	    var children = _ref.children,
	        closeModal = _ref.closeModal,
	        closeOnEsc = _ref.closeOnEsc,
	        closeOnOutsideClick = _ref.closeOnOutsideClick,
	        dataTn = _ref.dataTn,
	        isOpened = _ref.isOpened,
	        modalClass = _ref.modalClass,
	        wrapperClass = _ref.wrapperClass,
	        onOpen = _ref.onOpen;
	    return React.createElement(
	        FlexModalWrapper,
	        {
	            closeOnEsc: closeOnEsc,
	            closeOnOutsideClick: closeOnOutsideClick,
	            isOpened: isOpened,
	            onClose: closeModal,
	            className: wrapperClass + ' ' + css.wrapper,
	            onOpen: onOpen
	        },
	        React.createElement(
	            'div',
	            { className: modalClass || css.content },
	            React.Children.map(children, function (c) {
	                return React.cloneElement(c, { closeModal: closeModal, dataTn: dataTn });
	            })
	        )
	    );
	};

	Modal.defaultProps = {
	    closeOnEsc: true,
	    closeOnOutsideClick: true,
	    dataTn: 'default-tag',
	    modalClass: ''
	};

	Modal.propTypes = {
	    children: PropTypes.node,
	    closeModal: PropTypes.func,
	    closeOnEsc: PropTypes.bool,
	    closeOnOutsideClick: PropTypes.bool,
	    dataTn: PropTypes.string,
	    isOpened: PropTypes.bool,
	    modalClass: PropTypes.string,
	    wrapperClass: PropTypes.string,
	    onOpen: PropTypes.func
	};

	module.exports = Modal;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("react-modal-wrapper/dist/main.css");

/***/ },
/* 3 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-Modal-style---content---3KroD","wrapper":"src-Modal-style---wrapper---16j1C"};

/***/ },
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = require("react-modal-wrapper");

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var css = __webpack_require__(10);
	var React = __webpack_require__(7);
	var CloseIcon = __webpack_require__(12);

	var Header = function Header(_ref) {
	    var children = _ref.children,
	        closeModal = _ref.closeModal,
	        dataTn = _ref.dataTn,
	        headerClass = _ref.headerClass,
	        titleClass = _ref.titleClass;
	    return React.createElement(
	        'div',
	        { className: headerClass || css.header },
	        React.createElement(
	            'p',
	            { className: titleClass || css.title },
	            children
	        ),
	        React.createElement('div', { className: css.divider }),
	        React.createElement(
	            'div',
	            { className: css.close, onClick: closeModal, 'data-tn': dataTn + '-modal-close' },
	            React.createElement(CloseIcon, { className: css.closeButton })
	        )
	    );
	};

	Header.propTypes = {
	    children: React.PropTypes.node,
	    closeModal: React.PropTypes.func,
	    dataTn: React.PropTypes.string,
	    headerClass: React.PropTypes.string,
	    titleClass: React.PropTypes.string
	};

	module.exports = Header;

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-Header-style---header---1e0ET","title":"src-Header-style---title---1J0CJ","close":"src-Header-style---close---3RKdj","closeButton":"src-Header-style---closeButton---20ChF","divider":"src-Header-style---divider---_OrIy"};

/***/ },
/* 11 */,
/* 12 */
/***/ function(module, exports) {

	module.exports = require("dibs-vg/dist/react/close");

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(7);
	var classnames = __webpack_require__(14);
	var css = __webpack_require__(15);

	var Body = function Body(_ref) {
	    var children = _ref.children,
	        bodyClass = _ref.bodyClass,
	        dataTn = _ref.dataTn;
	    return React.createElement(
	        'div',
	        { className: classnames(bodyClass || css.body), 'data-tn': dataTn + '-modal-body' },
	        children
	    );
	};

	Body.propTypes = {
	    bodyClass: React.PropTypes.string,
	    children: React.PropTypes.node,
	    dataTn: React.PropTypes.string
	};

	module.exports = Body;

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = require("classnames");

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"body":"src-Body-style---body---19tjB"};

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/dibs-com-modal/dist/bundle.js
// module id = 574
// module chunks = 64